var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{ref:"vselect",attrs:{"multiple":"","taggable":_vm.taggable,"value":_vm.currentValue,"options":_vm.allOptions,"label":"label","placeholder":_vm.placeholder,"onSearch":_vm.searchEmail,"selectOnTab":true},on:{"input":_vm.input}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e2033004","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fields/SelectizeMultipleEmail.vue
// module id = null
// module chunks = 